import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from "./monitoring.service";

// Not injectable as singleton, set as provider for ErrorHandler in AppModule
@Injectable()
/**
 * Custom error handler to send all uncaught Exceptions / Errors to central monitoring (Application Insights)
 *
 * Application Insights SDK can not automatically catch Exceptions in Angular applications, since Angular itself
 * catches them and logs them to console. To retrieve Error information, a custom ErrorHandler has to be implemented
 * and injected into the app. See example.
 *
 * @example
 * In AppModule:
 *
 * ```
 * providers: [
 *   {provide: ErrorHandler, useClass: MonitoringErrorHandlerService}
 * ]
 * ```
 */
export class MonitoringErrorHandlerService extends ErrorHandler {

  constructor(
    private monitoring: MonitoringService
  ) {
    super();
  }

  handleError(error: Error) {
    // also use default implementation (log to console)
    super.handleError(error);
    // send to central monitoring
    this.monitoring.logException(error);
  }
}
